export default __webpack_public_path__ + "static/media/myAppsIcon.ad42d246.svg";